// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateStatusChangeModalVisibility = (propertyToUpdate, value) =>

    dispatch => {

        if (propertyToUpdate === 'isVisible') {

            addRemoveModalClass(value);

        }

        dispatch({
            propertyToUpdate,
            type: actions.UPDATE_PRODUCT_SEARCH_STATUS_CHANGE_MODAL_VISIBILITY,
            value
        });

    };



// WEBPACK FOOTER //
// ./src/product/search/action-creators/status-change-modal-visibility.js